import {
  Component,
  Input,
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { ProductPanelService } from '../../../product-panel/product-panel.service';
import * as _ from 'lodash';

import { BaseSegmentMixin } from './_base-segment-mixin';
import { ProductDetailsService } from '../../product-details.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import * as utils from 'utils/utils';


@Component({
  template: '',
})
export class BaseSegmentComponent extends BaseSegmentMixin implements AfterViewInit {

  headers: any[] = [];
  permissions: Array<string> = ['admin', 'catalog-edit'];

  @Input() itemDetail: any;

  @Input() declare data: any;

  @Input() async: AsyncSubject<any>;

  @Input() productGroupsData: any;

  constructor(
    protected productDetailsService: ProductDetailsService,
    protected productPanelService: ProductPanelService,
    protected permissionsService: PermissionsService,
  ) {
    super();
  }

  get displayData(): Array<any> {
    return _.filter(this.data, ['show_more', true]);
  }

  get displayEdit(): Boolean {
    return (
      this.itemDetail &&
      this.itemDetail.itemId &&
      _.indexOf([0, 1, 2], this.itemDetail.status) > -1 &&
      this.permissionsService.hasPermission(this.permissions)
    );
  }

  get displayShowMoreData(): Array<any> {
    return _.filter(this.data, ['show_more', false]);
  }

  ngAfterViewInit() {
    this.async.next(this.data);
    this.async.complete();
  }

  onEditButtonClick(segmentName: string) {
    if (!segmentName) { return console.warn('Segment name is undefined!'); }
    this.productPanelService.toggleProductPanelModal(true, segmentName, {panelType: ''});
  }

  public getItemProperty(item: any, path: string): any {
    const property = utils.getItemProperty(item, path, this.itemDetail);
    if (!property) {
      switch (item.type) {
        case 'list':
          return [];
        default:
          return '';
      }
    }
    return property;
  }


  public hasError(path: string, language?: string, index?: number) {
    return utils.hasServerError(this.itemDetail.validation, path, language, index);
  }

  public getFieldByName(name: string) {
    return utils.getFieldByName(name, this.data);
  }

  protected setItemsErrorMark(segmentData: any, data: any, path: string) {
    _.each(data, (item: any, index: number) => {
      _.some(segmentData, (segmentItem: any) => {
        item.hasError = this.hasError(this.getErrorPath(path, segmentItem.item_name, index));
        return item.hasError;
      });
      if (item.hasError) { return; }
    });

  }

  protected getErrorPath(path: string, itemName: string, index: number): string {
    return `${path}${'.' + index}.${itemName}`;
  }

  protected getGroup(groupCode: string, groupsData: Array<any>): any {
    // @ts-ignore
    return _.find(groupsData, {code: groupCode});
  }

  protected getGroupName(groupCode: string) {
    if (this.productGroupsData && this.productGroupsData.length) {
      const group = this.getGroup(groupCode, this.productGroupsData);
      if (group && group.name && group.name.length) {
        return group.name;
      }
    }
    return groupCode;
  }

  protected getSubGroupName(groupCode: string, subGroupCode: string) {
    if (this.productGroupsData && this.productGroupsData.length) {
      const group = this.getGroup(groupCode, this.productGroupsData);
      if (group && group.product_sub_group) {
        const subGroup: any = this.getGroup(subGroupCode, group.product_sub_group);
        if (subGroup && subGroup.name && subGroup.name.length) {
          return subGroup.name;
        }
      }
    }
    return subGroupCode;
  }
}
